/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Title_TailInputs */

const en_portal_week_title_tail = /** @type {(inputs: Portal_Week_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in your pocket.`)
};

const pl_portal_week_title_tail = /** @type {(inputs: Portal_Week_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w kieszeni.`)
};

/**
* | output |
* | --- |
* | "in your pocket." |
*
* @param {Portal_Week_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_title_tail = /** @type {((inputs?: Portal_Week_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_title_tail(inputs)
	return en_portal_week_title_tail(inputs)
});